import { Stack } from "@mui/material";
import { useSpacing } from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { EmailCycleRecipientsTable } from "../tables/EmailCycleRecipientsTable";

export const EmailCycleRecipientsTab: React.FC = () => {
  const spacing = useSpacing();

  return (
    <Stack
      padding={spacing.space2XL}
      height="100%"
      width="100%"
      alignItems="center"
    >
      <EmailCycleRecipientsTable />
    </Stack>
  );
};
